type ListPaginationBarProps = {
  totalCount: number;
  page: number;
  pageSize: number;
  onPrevious: () => void;
  onNext: () => void;
  pageSizeOptions?: number[];
  onPageSizeChange?: (pageSize: number) => void;
};

export function ListPaginationBar({
  totalCount,
  page,
  pageSize,
  onPrevious,
  onNext,
  pageSizeOptions,
  onPageSizeChange,
}: ListPaginationBarProps) {
  const totalPages = Math.max(1, Math.ceil(totalCount / Math.max(1, pageSize)));
  const showPager = totalCount > pageSize;
  const showPageSize = Boolean(pageSizeOptions?.length && onPageSizeChange);

  if (!showPager && !showPageSize) {
    return null;
  }

  return (
    <div className="erp-pagination">
      <div className="flex flex-wrap items-center gap-3">
        <span>
          {totalCount} registro(s)
          {showPager ? ` — pagina ${page} de ${totalPages}` : null}
        </span>
        {showPageSize ? (
          <label className="flex items-center gap-2 text-sm text-secondary-600">
            Itens por página
            <select
              className="rounded-lg border border-secondary-300 bg-white px-2 py-1 text-sm"
              title="Quantidade de registros exibidos por página"
              value={pageSize}
              onChange={(event) => onPageSizeChange?.(Number(event.target.value))}
            >
              {pageSizeOptions!.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        ) : null}
      </div>
      {showPager ? (
        <div className="erp-btn-actions">
          <button
            type="button"
            title="Ir para a página anterior"
            disabled={page <= 1}
            className="erp-btn-secondary disabled:opacity-40"
            onClick={onPrevious}
          >
            Anterior
          </button>
          <button
            type="button"
            title="Ir para a próxima página"
            disabled={page >= totalPages}
            className="erp-btn-secondary disabled:opacity-40"
            onClick={onNext}
          >
            Proxima
          </button>
        </div>
      ) : null}
    </div>
  );
}
